import React from 'react';

export const English = () => {
  return (
    <svg
      width="21"
      height="16"
      viewBox="0 0 21 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_363_15203)">
        <mask
          id="mask0_363_15203"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="21"
          height="16"
        >
          <path
            d="M19 0.5H2C0.89543 0.5 0 1.39543 0 2.5V13.5C0 14.6046 0.89543 15.5 2 15.5H19C20.1046 15.5 21 14.6046 21 13.5V2.5C21 1.39543 20.1046 0.5 19 0.5Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_363_15203)">
          <path
            d="M19 0.5H2C0.89543 0.5 0 1.39543 0 2.5V13.5C0 14.6046 0.89543 15.5 2 15.5H19C20.1046 15.5 21 14.6046 21 13.5V2.5C21 1.39543 20.1046 0.5 19 0.5Z"
            fill="#22438B"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.00061 1.5L0.974609 1.526L1.00061 3.5L17.9826 14.528L20.0196 14.491L19.9816 12.529L3.00061 1.5Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 1.5L1 2.5L19 14.5L20 13.5L2 1.5Z"
            fill="#C7152A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.0002 1.5H20.0002V3.5C20.0002 3.5 8.25023 10.896 3.01823 14.528C2.95523 14.572 1.02023 14.531 1.02023 14.531L0.865234 12.63L18.0002 1.5Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.043 1.47192L20 2.49992L2 14.4999L1 13.4999L19.043 1.47192Z"
            fill="#C7152A"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 1.5H13V5.5H20V10.5H13V14.5H8V10.5H1V5.5H8V1.5Z"
            fill="white"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9 1.5H12V6.5H20V9.5H12V14.5H9V9.5H1V6.5H9V1.5Z"
            fill="#C7152A"
          />
          <path
            d="M19 1H2C1.17157 1 0.5 1.67157 0.5 2.5V13.5C0.5 14.3284 1.17157 15 2 15H19C19.8284 15 20.5 14.3284 20.5 13.5V2.5C20.5 1.67157 19.8284 1 19 1Z"
            stroke="black"
            strokeOpacity="0.1"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_363_15203">
          <rect
            width="21"
            height="15"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
